import { useHoverIntent } from '@hooks/useHoverIntent';
import SvgAngleDown from '@img/icons/angle-down.svg';
import * as React from 'react';
import NavigationDropdown from '../NavigationDropdown/NavigationDropdown';
import S from './Navigation.styles';
const Navigation = ({ items }) => {
    const { handleMouseEnter, handleMouseLeave, resetNavigation } = useHoverIntent();
    if (!items || items.length === 0) {
        return null;
    }
    return (React.createElement(S.Nav, { onMouseLeave: resetNavigation },
        React.createElement(S.List, null, items.map((item) => {
            /** Only applies if an item has children, and not a further nested level of children */
            const shouldShowDropdownType = item.children &&
                item.children.length > 0 &&
                !item.children.some((child) => child.children && child.children.length > 0);
            const dropdownTypeAttrs = shouldShowDropdownType && item.dropdownType
                ? { 'data-dropdown-type': item.dropdownType }
                : {};
            const resetHandlers = !(item.children && item.children.length > 0);
            return (React.createElement(S.Item, { key: item.id, "data-id": item.id, ...dropdownTypeAttrs, onMouseEnter: (e) => resetHandlers ? resetNavigation() : handleMouseEnter(e, item.id, 'nav'), onMouseLeave: (e) => !resetHandlers ? resetNavigation() : handleMouseLeave(e, item.id, 'nav') },
                React.createElement(S.Link, { href: item.url, target: item.target ?? '_self' },
                    item.text,
                    !!item.children?.length && React.createElement(SvgAngleDown, null)),
                !!item.children?.length && (React.createElement(NavigationDropdown, { items: item.children, title: shouldShowDropdownType && item.dropdownType === 'two-column'
                        ? item.text
                        : undefined }))));
        }))));
};
export default Navigation;
